import { render, staticRenderFns } from "./hourglass-loader.vue?vue&type=template&id=3487dc20&scoped=true&"
import script from "./hourglass-loader.vue?vue&type=script&lang=js&"
export * from "./hourglass-loader.vue?vue&type=script&lang=js&"
import style0 from "./hourglass-loader.vue?vue&type=style&index=0&id=3487dc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487dc20",
  null
  
)

export default component.exports